import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import endpoints from "../../api/endpoints";
import { saveAdminDetails } from "../auth/authSlice";
import { toast } from "react-toastify";
import en from "../../locales/en.json";

export const getMe = async (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    setLoading(true);
    const response = await axiosInstance.get(endpoints.profile.getMe);

    if (response?.data?.result) {
      setLoading(false);
      return response.data.result;
    } else {
      setLoading(false);
      return null; // Return null if no data found
    }
  } catch (error) {
    console.error("Error fetching profile:", error);
    setLoading(false);
    return null; // Return null in case of error
  }
};

export const updateProfile = async (
  data: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  navigate: NavigateFunction,
  backUrl: string,
  dispatch: React.Dispatch<any>
) => {
  try {
    setLoading(true);
    const response = await axiosInstance.put(endpoints.profile.updateMe, data);
    if (response?.data?.result) {
      toast.success(en.profile.successProfileUpdate);
      dispatch(
        saveAdminDetails({
          admin: response.data.result,
          isAuthenticated: true,
        })
      );
      setLoading(false);
      navigate(backUrl || `/profile`);
    } else {
      setLoading(false);
      toast.error(response?.data?.message || en.profile.failedProfileUpdate);
    }
  } catch (error: any) {
    setLoading(false);
    toast.error(
      error?.response?.data?.message || en.profile.failedProfileUpdate
    );
  }
};

export const updatePassword = async (
  data: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    setLoading(true);
    const response = await axiosInstance.put(
      endpoints.profile.updatePassword,
      data
    );
    if (response?.data?.status === 200) {
      toast.success(en.profile.successPasswordUpdate);
      setLoading(false);
      return true; // Indicate success
    } else {
      setLoading(false);
      toast.error(response?.data?.message || en.profile.failedPasswordUpdate);
      return false; // Indicate failure
    }
  } catch (error: any) {
    setLoading(false);
    toast.error(
      error?.response?.data?.message || en.profile.failedPasswordUpdate
    );
    return false; // Indicate failure
  }
};
